import React from "react";
import { Link } from "react-router-dom";

export const miscs = [
  {
    name: "Plastic Cutlery",
    images: [
      "/images/Cutlery/fork.png",
      "/images/Cutlery/sspoon.png",
      "/images/Cutlery/tspoon.png",
      "/images/Cutlery/knife.png",
      "/images/Cutlery/kit.png",
    ],
    description: `Choose from medium and heavy duty, black and white color. Sold unwrapped in bulk or wrapped sets.`,
    features: [
      "Durable",
      "Disposable",
      "Economical",
      "Black & White Available",
    ],
    specs: [
      {
        label: "SKU",
        values: [
          "MDF",
          "MDSS",
          "MDTS",
          "MDK",
          "MDKFSN",
          "MDKFSNSP",
          "HDF",
          "HDSS",
          "HDTS",
          "HDK",
        ],
      },
      {
        label: "Name",
        values: [
          "Medium Duty Forks",
          "Medium Duty Soup Spoons",
          "Medium Duty Tea Spoons",
          "Medium Duty Knives",
          "Medium Duty Knives, Fork, Spoon, Napkin Set",
          "Medium Duty Knives, Fork, Spoon, Napkin, Salt & Pepper Set",
          "Heavy Duty Forks",
          "Heavy Duty Soup Spoons",
          "Heavy Duty Tea Spoons",
          "Heavy Duty Knives",
        ],
      },
      {
        label: "Case Pack",
        values: [
          "1000pc",
          "1000pc",
          "1000pc",
          "1000pc",
          "250pc",
          "250pc",
          "1000pc",
          "1000pc",
          "1000pc",
          "1000pc",
        ],
      },
    ],
    link: "/misc/cutlery",
  },
  {
    name: "Napkins",
    images: [
      "/images/Napkin/dispenser.png",
      "/images/Napkin/bev.png",
      "/images/Napkin/dinner.png",
    ],
    description: `Take care of your customers with various napkins. `,
    features: ["Beverage", "Dinner", "Dispenser"],
    specs: [
      {
        label: "SKU",
        values: ["BevNap", "DinNap", "DisNap"],
      },
      {
        label: "Name",
        values: [
          "Beverage Napkins",
          "Dinner Napkins",
          "Interfold Dispenser Napkins",
        ],
      },
      {
        label: "Product Dimensions (in)",
        values: ["9 × 9", "15 × 17", "6.5 × 8.5"],
      },
      {
        label: "Case Pack",
        values: ["4000pc", "3000pc", "6000pc"],
      },
    ],
    link: "/misc/napkin",
  },
  {
    name: "Black Gloves",
    images: ["/images/Glove/gloves.png", "/images/Glove/box.png"],
    description: `Black hybrid vinyl/nitrile gloves. Ideal for food service industry. Small, Medium, Large, X-Large available.`,
    features: [
      "Ambidextrous",
      "Food Safe",
      "Latex Free",
      "Flexible",
      "Durable",
      "Multi-Purpose",
      "Powder Free",
      "3mil Thick",
    ],
    specs: [
      {
        label: "SKU",
        values: ["GLP", "GLC"],
      },
      {
        label: "Name",
        values: ["Pack of Gloves", "Case (10 Packs) "],
      },
      {
        label: "Quantity",
        values: ["100pc", "1000pc"],
      },
    ],
    link: "/misc/glove",
  },
  {
    name: "Foil & Film",
    images: [
      "/images/Foil/roll.png",
      "/images/Foil/sheet.png",
      "/images/Foil/film.png",
    ],
    description: `Take care of your food with foil and cling wrap!`,
    features: ["Convenient", "Heavy Duty"],
    specs: [
      {
        label: "SKU",
        values: ["FoilR", "FoilS", "FilmW"],
      },
      {
        label: "Name",
        values: [
          "Foil Roll with Cutterbox",
          "Foil Popup Sheets",
          "Foodservice Film with Cutterbox",
        ],
      },
      {
        label: "Product Dimensions (in)",
        values: ["18 × 500'", "12 × 10.75", "18 × 2000'"],
      },
      {
        label: "Case",
        values: ["500 ft", "3000 sheets", "2000 ft"],
      },
    ],
    link: "/misc/foil",
  },
];

const Misc = () => {
  return (
    <div className="bg-containx-navy min-h-screen p-6">
      <h1 className="text-4xl font-bold text-center mb-6 text-white">
        Additional Products
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {miscs.map((misc, index) => (
          <div
            key={index}
            className="bg-containx-charcoal/30 text-white rounded-lg shadow-md overflow-hidden hover:bg-containx-beige/50 hover:text-containx-navy transition-shadow duration-200"
          >
            <Link to={misc.link}>
              <img
                src={misc.images[0]}
                alt={misc.name}
                className="w-full h-48 object-contain"
              />
              <div className="p-4">
                <h2 className="text-xl font-semibold">{misc.name}</h2>
                <p className="text-gray-700">{misc.description}</p>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Misc;
